import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { sessionStorage } from '@shared/helpers/storage'

export const useSelfTestReevaluationStore = defineStore(
  'selfTestReevaluation',
  () => {
    // State
    const painAverage = ref(-1)
    const painWorst = ref(-1)
    const painNow = ref(-1)
    const activityChores = ref(-1)
    const activityStairs = ref(-1)
    const activityWalk = ref(-1)
    const activityErrands = ref(-1)
    const fearOfMovement = ref(-1)
    const productivity = ref(-1)
    const confidence = ref(-1)
    const phqInterest = ref(-1)
    const phqFeeling = ref(-1)
    const gadNervous = ref(-1)
    const gadControl = ref(-1)
    const gadWorrying = ref(-1)
    const gadRelaxing = ref(-1)
    const gadRestless = ref(-1)
    const gadIrritable = ref(-1)
    const gadAfraid = ref(-1)
    const selectedPastConsultations = ref([])
    const selectedPastMedications = ref([])

    // Getters
    const selfTestReevaluationsAnswers = computed(() =>
      Object.fromEntries(
        [
          ['pain_average', painAverage.value],
          ['pain_worst', painWorst.value],
          ['pain_now', painNow.value],
          ['activity_chores', activityChores.value],
          ['activity_stairs', activityStairs.value],
          ['activity_walk', activityWalk.value],
          ['activity_errands', activityErrands.value],
          ['fear-of-movement', fearOfMovement.value],
          ['productivity', productivity.value],
          ['confidence', confidence.value],
          ['phq-interest', phqInterest.value],
          ['phq-feeling', phqFeeling.value],
          ['gad-nervous', gadNervous.value],
          ['gad-control', gadControl.value],
          ['gad-worrying', gadWorrying.value],
          ['gad-relaxing', gadRelaxing.value],
          ['gad-restless', gadRestless.value],
          ['gad-irritable', gadIrritable.value],
          ['gad-afraid', gadAfraid.value],
          ['past_consultations', selectedPastConsultations.value],
          ['past_medications', selectedPastMedications.value],
        ].filter(
          ([, value]) =>
            // filter out entries that are an array but don't have entries
            (Array.isArray(value) && value.length > 0) ||
            // filter out entries that are a number but are negative
            (Number.isInteger(value) && value > -1),
        ),
      ),
    )

    return {
      // State
      painAverage,
      painWorst,
      painNow,
      activityChores,
      activityStairs,
      activityWalk,
      activityErrands,
      fearOfMovement,
      productivity,
      confidence,
      phqInterest,
      phqFeeling,
      gadNervous,
      gadControl,
      gadWorrying,
      gadRelaxing,
      gadRestless,
      gadIrritable,
      gadAfraid,
      selectedPastConsultations,
      selectedPastMedications,
      // Getters
      selfTestReevaluationsAnswers,
    }
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
)

export default useSelfTestReevaluationStore
